import { Link, Icon } from "@mobi/ds"
import If from "@mobi/components/If"
import isClient from "@mobi/utils/browser/isClient"
import OutsideClick from "@mobi/utils/browser/outsideClick"
import IconUser from "@mobi/ds/static/icons/outlined/user.svg"
import IconChevronRight from "@mobi/ds/static/icons/outlined/seta-direita.svg"
import "./DropdownMenu.scss"

const DropdownMenu = ({
  menuContent,
  show,
  toggleMethod,
  actionButtonRef,
  handleMenuOpenAccountLink,
  utmsHeaderMenuCheckingAccount,
  utmsHeaderMenuOpenAccount,
  openAccountLink = "/?utm_source=st&utm_medium=nd&utm_campaign=st-conv-nd-st-nd-all&utm_content=nd-nd-nd-iacnta-nd-pfaqu-MT00001342-rvproduto",
  handleSubmenuOpenAccountLink,
}) => {
  return (
    <If
      condition={show && window.innerWidth >= 1024}
      renderIf={
        <OutsideClick
          onClickOutside={toggleMethod}
          actionButtonRef={actionButtonRef}
        >
          <div className={`ds-header-dropdown__menu`}>
            <div className={`ds-header-dropdown__menu-wrapper`}>
              <div className="ds-header-dropdown__main-content">
                {menuContent?.column?.map(
                  ({ link: contentItems, submenu_title: submenuTitle }) => (
                    <div
                      className="ds-header-dropdown__content-wrapper"
                      key={`content-wrapper-${submenuTitle}`}
                    >
                      <span
                        className="ds-header-dropdown__content-title"
                        role="heading"
                        aria-level="2"
                      >
                        {submenuTitle}
                      </span>
                      <ul className="ds-header-dropdown__content-list">
                        {contentItems?.map(
                          ({ link_properties: { title, href } }) => (
                            <li
                              className="ds-header-dropdown__content-list-item"
                              key={`dropdown-content-list-${href}`}
                            >
                              <If
                                condition={title === "conta-corrente"}
                                renderIf={
                                  <Link
                                    onClick={handleSubmenuOpenAccountLink}
                                    href={`https://www.itau.com.br/contas/conta-corrente${openAccountLink}${utmsHeaderMenuCheckingAccount}`}
                                    alt="Link para conta corrente"
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {title}
                                  </Link>
                                }
                                renderElse={<Link href={href}>{title}</Link>}
                              />
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  )
                )}
                <div className="ds-header-dropdown__extra-content">
                  <span
                    className="ds-header-dropdown__content-title"
                    role="heading"
                    aria-level="2"
                  >
                    {menuContent?.fancy_links?.submenu_title}
                  </span>
                  <ul className="ds-header-dropdown__content-list">
                    {menuContent?.fancy_links?.link?.map(
                      ({
                        background_color: theme,
                        link_properties: { href, title },
                        icon_selection: icon,
                      }) => {
                        const iconName = icon?.replace("icon-itaufonts_", "")
                        return (
                          <li
                            className={`ds-header-dropdown__fancy-links ds-header-dropdown__fancy-links--${theme}`}
                            key={`dropdown-menu-fancy-${href}`}
                          >
                            <Link href={href}>
                              <If
                                condition={iconName}
                                renderIf={
                                  <Icon
                                    className="icon-fancy"
                                    icon={iconName}
                                    type="outlined"
                                  />
                                }
                              ></If>
                              {title}
                              <IconChevronRight className="icon-chevron" />
                            </Link>
                          </li>
                        )
                      }
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="ds-header__menu-open-account ds-header__menu-open-account--desktop">
              <Link
                href={`https://www.itau.com.br/contas/conta-corrente?utm_source=st&utm_medium=nd&utm_campaign=st-conv-nd-st-nd-all&utm_content=nd-nd-nd-iacnta-nd-pfaqu-MT00001342-rvproduto${utmsHeaderMenuOpenAccount}`}
                target="_blank"
                rel="noreferrer"
                onClick={handleMenuOpenAccountLink}
              >
                <IconUser className="icon-user" />
                <span>Ainda não é cliente Itaú? Abra sua conta.</span>
                <IconChevronRight className="icon-chevron" />
              </Link>
            </div>
          </div>
        </OutsideClick>
      }
      renderElse={<></>}
    />
  )
}

export default DropdownMenu
